import dentalTourismImage from "../Images/Dental_Tourism.png";

const dentalTourismData = {
  title:
    "Dental Tourism in Hubli – Affordable World-Class Care at Dhotrad’s Sunny Dental and Orthodontic Clinics",

  fullContent: `

  <img 
  src="${dentalTourismImage}" 
  alt="Dental Tourism at Dhotrad’s Sunny Dental and Orthodontic Clinics"
  class="content-image"
/>
    <p>
      Looking for safe, high-quality, and affordable dental treatment in India?
      Welcome to <strong>Dhotrad’s Sunny Dental and Orthodontic Clinics</strong>,
      a trusted destination for dental tourism in Hubli.
    </p>

    <p>
      We help NRIs and international patients receive advanced dental care at
      <strong>60–80% lower costs</strong> compared to the USA, UK, and Europe—without
      compromising on quality, hygiene, or technology.
    </p>

    <h3>Why Choose Hubli for Dental Tourism?</h3>
    <ul>
      <li>Lower treatment costs compared to metro cities</li>
      <li>Minimal waiting time and faster treatment completion</li>
      <li>Calm and stress-free recovery environment</li>
      <li>Excellent air, rail, and road connectivity</li>
      <li>Ideal for NRIs visiting Karnataka, Goa, or Maharashtra</li>
    </ul>

    <p>
      Hubli is fast emerging as a preferred dental tourism destination, offering
      personalised care, relaxed recovery, and world-class dentistry without the
      stress and expense of metro cities.
    </p>

    <h3>Why Dhotrad’s Sunny Dental is a Preferred Dental Tourism Clinic</h3>
    <ul>
      <li>Specialist-led advanced dentistry by experienced MDS doctors</li>
      <li>International-standard dental technology and equipment</li>
      <li>Strict sterilisation and patient safety protocols</li>
      <li>Transparent and ethical pricing with no hidden costs</li>
      <li>Treatment plans designed around your travel schedule</li>
    </ul>

    <h3>Advanced Dental Technology We Use</h3>
    <ul>
      <li>Digital dental X-rays and CBCT imaging</li>
      <li>Premium dental implant systems</li>
      <li>Zirconia and ceramic crowns</li>
      <li>Clear aligners and modern orthodontic braces</li>
      <li>High-level infection control and sterilisation systems</li>
    </ul>

    <h3>Popular Dental Tourism Treatments We Offer</h3>
    <ul>
      <li>Dental implants and full-mouth rehabilitation</li>
      <li>Root canal treatment with crowns</li>
      <li>Smile makeover and cosmetic dentistry</li>
      <li>Braces and clear aligners</li>
      <li>Teeth whitening and dental jewellery</li>
      <li>Preventive and comprehensive dental check-ups</li>
    </ul>

    <h3>Comparative Cost of Dental Treatments</h3>

    <table class="content-table">
      <thead>
        <tr>
          <th>Treatment</th>
          <th>Cost at Dhotrad’s <br>Sunny Dental and Orthodontic Clinic
    India (INR)
    </th>
          <th>Cost in USA (in USD)</th>
          <th>Cost in UK 
    (in GBP)
    </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Dental Consultation</td>
          <td>₹300 – ₹1,000</td>
          <td>$100 – $200</td>
          <td>£50 – £100</td>
        </tr>

        <tr>
          <td>Dental X-rays (IOPA / OPG / CBCT)</td>
          <td>₹350 – ₹5,000</td>
          <td>$25 – $175</td>
          <td>£10 – £140</td>
        </tr>

        <tr>
          <td>Composite Filling (per tooth)</td>
          <td>₹1,500 – ₹4,000</td>
          <td>$150 – $450</td>
          <td>£90 – £300</td>
        </tr>

        <tr>
          <td>Root Canal Treatment</td>
          <td>₹4,500 – ₹15,000</td>
          <td>$600 – $1,600</td>
          <td>£300 – £900</td>
        </tr>

        <tr>
          <td><I>(Front tooth → molar)</I></td>
          <td><I>(front lower, molar higher)</I></td>
          <td><I>(molar often $1k–$1.6k)</I></td>
          <td><I>(simple → complex)</I></td>
        </tr>
        <tr>
          <td>Dental Crown<br/>(PFM / Zirconia / Porcelain)</td>
          <td>₹3,000 – ₹25,000</td>
          <td>$800 – $2,500</td>
          <td>£600 – £1,800</td>
        </tr>

        <tr>
          <td>Single Dental Implant (complete)</td>
          <td>₹25,000 – ₹2,50,000</td>
          <td>$2,000 – $6,000+</td>
          <td>£2,000 – £4,500+</td>
        </tr>

        <tr>
          <td>Simple Tooth Extraction</td>
          <td>₹800 – ₹3,000</td>
          <td>$75 – $300</td>
          <td>£50 – £200</td>
        </tr>

        <tr>
          <td>Scaling & Polishing</td>
          <td>₹1,500 – ₹6,000</td>
          <td>$75 – $250</td>
          <td>£50 – £150</td>
        </tr>

        <tr>
          <td>Deep Cleaning</td>
          <td>₹3,000 – ₹6,000</td>
          <td>$300 – $800 / quadrant</td>
          <td>£150 – £400</td>
        </tr>
      </tbody>
    </table>


    <table class="content-table">
      <thead>
        <tr>
          <th>Treatment</th>
          <th>Cost at Dhotrad’s <br>Sunny Dental and Orthodontic Clinic
    India (INR)
    </th>
          <th>Cost in USA (in USD)</th>
          <th>Cost in UK 
    (in GBP)
    </th>
        </tr>
      </thead>
      <tbody>
<tr>
      <td>In-office Teeth Whitening</td>
      <td>₹4,000 – ₹15,000</td>
      <td>$300 – $1,000</td>
      <td>£200 – £600</td>
    </tr>

    <tr>
      <td>Fixed Braces (Full Treatment)</td>
      <td>₹40,000 – ₹1,50,000</td>
      <td>$3,000 – $8,000+</td>
      <td>£2,000 – £6,000+</td>
    </tr>

    <tr>
      <td>Clear Aligners (Full Course)</td>
      <td>₹1,00,000 – ₹3,50,000+</td>
      <td>$3,000 – $8,000+</td>
      <td>£2,000 – £7,000+</td>
    </tr>

    <tr>
      <td>Dental Jewellery (Tooth Gems)</td>
      <td>₹4,000 – ₹15,000</td>
      <td>$300 – $1,000</td>
      <td>£200 – £600</td>
    </tr>
      </tbody>
    </table>
    

        <p><strong>Even after travel expenses, patients save significantly.</strong></p>

    <hr />

    <h3>⭐ FAQs – Dental Tourism at Dhotrad’s Sunny Dental, Hubli</h3>

    <h4>Is dental treatment in Hubli safe for international patients?</h4>
    <p>
      Yes. We follow international sterilisation standards, use certified
      materials, and strictly adhere to globally accepted dental protocols.
    </p>

    <h4>How much can I save with dental tourism in Hubli?</h4>
    <p>
      Most patients save <strong>60–80%</strong> compared to treatment costs in
      the USA or UK.
    </p>

    <h4>Can treatment be planned before I travel?</h4>
    <p>
      Yes. You can share photos, X-rays, or reports online, and we’ll provide a
      tentative treatment plan and cost estimate in advance.
    </p>

    <h4>How many visits are required?</h4>
    <ul>
      <li><strong>Implants:</strong> 2–3 visits (some cases allow immediate loading)</li>
      <li><strong>Root canal & crown:</strong> 2–3 visits</li>
      <li><strong>Aligners:</strong> Initial visit + remote follow-ups possible</li>
    </ul>

    <h4>Is Hubli well connected for travel?</h4>
    <p>
      Yes. Hubli has an airport, a major railway junction, and excellent road
      connectivity.
    </p>

    <h4>Do you provide post-treatment support?</h4>
    <p>
      Yes. We provide treatment reports, X-rays, and guidance to help coordinate
      with your local dentist abroad.
    </p>

    <hr />

    <h3>📍 Your Trusted Dental Tourism Clinic in Hubli</h3>
    <p>
      At <strong>Dhotrad’s Sunny Dental and Orthodontic Clinics, Hubli</strong>,
      our mission is simple:
    </p>
    <p>
      <strong>
        World-class dentistry, honest pricing, and personalised care — under one
        roof.
      </strong>
    </p>

  `,
};

export default dentalTourismData;
